// Filter options
export const typeOptions = [
  { id: "membership_type", name: "Membership Type" },
  { id: "category", name: "Category" },
  { id: "referral", name: "Referral" }
];

export const customerTypeOptions = [
  { id: "client", name: "Client" },
  { id: "member", name: "Member" }
];

export const referralModeOptions = [
  { id: "referral_category", name: "Referral Category" },
  { id: "referral_type", name: "Referral Type" }
];
